export class Tender {
  id: string;
  label: string;
  creationDateTime: string;
  publicationDate: string;
  status: TenderStatus;
  proposals: Proposal[];
  contactedLenders: Lender[];
}

export enum TenderStatus {
  INITIALIZED= 'INITIALIZED',
  DRAFT = 'DRAFT',
  READY_TO_PUBLISH = 'READY_TO_PUBLISH',
  PUBLISHED = 'PUBLISHED',
  ONGOING_ANALYSIS = 'ONGOING_ANALYSIS',
  CLOSED = 'CLOSED'
}

export class Proposal {
  consolidationPeriodInYear: number;
  consolidationPeriodInMonth: number;
  euriborMarginUsedForAnalyse: number;
  rateType: string;
  lender: Lender;
}

export class Lender {
  label: string;
  code: string;
  urlLogo: string;
}
